function e(n) {
  return n === null ? void 0 : n;
}
export {
  e as n
};
//# sourceMappingURL=nullToUndefined-Ba7Hd5zS.mjs.map
